$(function() {

    var $actionModal = $('.action-modal');
    var savedFormData = {};


    var getStepData = function($modalContent, step) {
        var steps = $modalContent.data('steps');
        return steps[step];
    };

    var getSavedFormData = function($modalContent) {
        var savedFormData = $modalContent.data('saved-form-data');
        if (typeof savedFormData === 'undefined' || savedFormData === null) {
            savedFormData = {};
            $.each($modalContent.data('steps'), function(step, value) {
                savedFormData[step] = {}
                savedFormData[step] = {
                    'checkbox': {},
                    'select': {}
                };
            })
        }
        return savedFormData;
    };

    var loadSavedFormData = function($modalContent) {
        var savedFormData = getSavedFormData($modalContent);
        var data = savedFormData[$modalContent.data('step')];

        $.each(data['checkbox'], function(name, value) {
            if (value) {
                $('input[type=\'checkbox\'][name=\'' + name + '\']').prop('checked', true);
            }
        });

        $.each(data['select'], function(name, value) {
            if (value) {
                $('select[name=\'' + name + '\']').val(value);
            }
        });
    };

    var setStep = function($modalContent, step) {
        $modalContent.data('step', step);

        var shownSteps = getShownSteps($modalContent);
        shownSteps[step] = step;
        $modalContent.data('shown-steps', shownSteps);

        var firstStep = $modalContent.data('first-step');
        var lastStep = $modalContent.data('last-step');

        var $btnContinue = $('[data-step-btn="continue"]');
        var $btnBack = $('[data-step-btn="back"]');
        var $btnSend = $('[data-step-btn="send"]');

        if (step === firstStep && step === lastStep) {
            $btnContinue.hide();
            $btnBack.hide();
            $btnSend.show();
        }
        else if (step === firstStep) {
            $btnContinue.show();
            $btnBack.hide();
            $btnSend.hide();
        }
        else if (step === lastStep) {
            $btnContinue.hide();
            $btnBack.show();
            $btnSend.show();
        } else {
            $btnContinue.show();
            $btnBack.show();
            $btnSend.hide();
        }
    };

    var getShownSteps = function($modalContent) {
        var shownSteps = $modalContent.data('shown-steps');
        if (typeof shownSteps === 'undefined') {
            shownSteps = {};
        }
        return shownSteps;
    };

    var sendStep = function($modalContent, $form, step) {
        var $modalBody = $modalContent.find('.modal-body');
        var $modalAlerts = $modalContent.find('.modal-alerts');
        var stepData = getStepData($modalContent, step)

        var shownSteps = getShownSteps($modalContent);

        var data = $form.serializeArray();
        if (typeof shownSteps[step] === 'undefined') {
            $.each(stepData['defaultValue'], function(key, value) {
                data.push({name: key, value: value});
            });
        }

        $modalAlerts.html('').hide();

        $.ajax({
            url: stepData['url'],
            method: 'POST',
            data: data,
            success: function(response) {
                if (response.status === 'success') {
                    $modalContent.find('.modal-body').html(response.body);
                    setTimeout(function() {
                        window.chosenLoad();
                        window.select2Init();
                    }, 100);

                    setStep($modalContent, step);
                    loadSavedFormData($modalContent);
                } else {
                    $modalAlerts.html($('<div/>').addClass('alert alert-danger').html(response.body ?? response.message)).show();
                }
            },
            error: function() {
                $modalBody.html($('<div/>').addClass('alert alert-danger').html('error step'));
            }
        });
    };

    $actionModal.delegate('[data-step-btn="continue"], [data-step-btn="back"]', 'click', function(ev) {
        ev.preventDefault();

        var $modal = $(this).closest('.action-modal');
        var $form = $modal.find('form');
        var $modalContent = $modal.find('.modal-content');
        var step = $modalContent.data('step');

        if ($(this).data('step-btn') === 'continue') {
            step = step + 1;
        } else if ($(this).data('step-btn') === 'back') {
            step = step - 1;
        }
        sendStep($modalContent, $form, step);
    });

    $actionModal.delegate('input[type="checkbox"], select', 'change', function(ev) {
        var $modal = $(this).closest('.action-modal');
        var $form = $modal.find('form');
        var $modalContent = $modal.find('.modal-content');
        var step = $modalContent.data('step');
        if(!step) return ;
        var savedFormData = getSavedFormData($modalContent);

        if (!$.isEmptyObject(savedFormData)) {
            if ($(this).is('select')) {
                savedFormData[step]['select'][$(this).attr('name')] = $(this).val();
            } else {
                savedFormData[step]['checkbox'][$(this).attr('name')] = $(this).is(':checked');
            }
            $modalContent.data('saved-form-data', savedFormData);

            sendStep($modalContent, $form, step);
        }
    });

    $(document).on('change', '.action-modal [data-modal-reload-change]', function(ev) {
        var $modal = $(this).closest('.action-modal');
        var $form = $modal.find('form');
        var $modalContent = $modal.find('.modal-content');
        var step = $modalContent.data('step');

        sendStep($modalContent, $form, step);
        setStep($modalContent, step);
    });

    $(document).on('click', '[data-action-modal]', function(ev) {
        ev.preventDefault();

        if ($('body').data('redirect-to-homepage')) {
            window.location.href = '/admin/';
            return false;
        }

        var $link = $(this);
        loadModal(
            ($link.attr('href') ? $link.attr('href') : $link.data('url')),
            $link.data('values'),
            $link.data('back-url'),
            $link.data('method')
        )
    });

    function loadModal(url, requestData = [], backUrl = '', method = 'GET') {
        var $modal = $('.action-modal');

        if (url.indexOf('/product/translate') !== -1) {
            location.hash = 'translate';
        }
        if (url.indexOf('/product/listed') !== -1) {
            location.hash = 'listed';
        }


        $modal.modal('show');
        var $form = $modal.find('form');
        var $modalContent = $modal.find('.modal-content');
        var $modalBody = $modalContent.find('.modal-body');
        var $modalDialog = $modal.find('.modal-dialog');

        let translator = new I18n; translator.trans('javascript.loading');

        $modalContent.addClass('loading');

        $modalContent.find('.modal-header-content').html('');
        $modalContent.find('.modal-footer-content').html('');
        $modalContent.find('.modal-footer-left-content').html('');
        $modalContent.find('.modal-header-help').html('');
        $modalContent.find('.modal-form-hidden-element-content').html('');
        $modalBody.html('<div class="text-center"><img width="10" height="10" src="/images/ajax-loader.gif"> ' + translator.trans('javascript.loading') + '</div>');
        $modalContent.data('saved-form-data', null);
        $modalContent.data('shown-steps', {})
        $modalContent.data('steps', {})

        $modal.attr('data-type', '');

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: url,
            method: method,
            data: {'data': JSON.stringify(requestData), 'back-url': backUrl},
            success: function(data) {

                // pokud nás prohlížeč přesměruje jinam např. neuatorizovaný požadavek, takže nemáme json, tak zobrazím v iframe
                if (typeof data === 'string') {
                    let $iframe = $('<iframe />').css({'width': '100%', 'height': '500px', 'border': 'none'});
                    $modalBody.append($iframe);
                    $modalBody.find('iframe').contents().find('body').html(data);
                } else {

                    if (data.status === 'success') {

                        $modalDialog
                            .removeClass('modal-sm')
                            .removeClass('modal-lg')
                            .removeClass('modal-big');

                        if (typeof data.dismiss !== "undefined" && data.dismiss === false){
                            $modalDialog.find('[data-dismiss]').addClass('d-none');
                        } else {
                            $modalDialog.find('[data-dismiss]').removeClass('d-none');
                        }
                        if (typeof data.size !== "undefined" && data.size) {
                            $modalDialog.addClass(data.size);
                        }else{
                            $modalDialog.addClass('modal-lg');
                        }

                        $modalBody.html(data.body);
                        if (typeof data.header !== "formUrl") {
                            $form.attr('action', data.formUrl);
                        }
                        if (typeof data.header !== "formEncType") {
                            $form.attr('enctype', data.formEncType ? data.formEncType : 'application/x-www-form-urlencoded');
                        }
                        if (typeof data.formName !== "undefined") {
                            $form.attr('data-form-name', data.formName);
                        } else {
                            $form.attr('data-form-name', '');
                        }
                        if (typeof data.header !== "undefined") {
                            $modalContent.find('.modal-header-content').html(data.header);
                        }
                        if (typeof data.helpLink !== "undefined") {
                            $modalContent.find('.modal-header-help').html(data.helpLink);
                        }
                        if (typeof data.footer !== "undefined") {
                            $modalContent.find('.modal-footer-content').html(data.footer);
                        }
                        if (typeof data.hiddenElements !== "undefined") {
                            $modalContent.find('.modal-form-hidden-element-content').html(data.hiddenElements);
                        }
                        if (typeof data.backUrl !== "undefined") {
                            $modalContent.find('.modal-form-hidden-element-content').append(
                                $('<input/>').attr('type', 'hidden').attr('name', '_back-url').val(data.backUrl)
                            );
                        }
                        if (typeof data.footerLeft !== "undefined") {
                            $modalContent.find('.modal-footer-left-content').html(data.footerLeft);
                        }
                        if (typeof data.type !== "undefined") {
                            $modal.attr('data-type', data.type);
                        }
                        if (typeof data.data !== "undefined") {
                            $.each(data.data, function(key, value) {
                                $modalContent.data(key, value);
                            });
                        }

                        $modalContent.removeClass('loading');
                        $modal.modal('show');

                        if (typeof data.data !== "undefined" && typeof data.data.steps !== "undefined") {
                            sendStep($modalContent, $form, 0);
                            setStep($modalContent, 0);
                        }
                        else {
                            setTimeout(function() {
                                window.chosenLoad();
                                window.select2Init();
                            }, 100);
                        }
                    }
                    else {
                        $modalBody.html($('<div/>').addClass('alert alert-danger').html(data.body ?? data.message));
                    }
                }
            },
            error: function(data) {
                $modalBody.html($('<div/>').addClass('alert alert-danger').html('error'));
            }
        });
    }

    window.loadModal = loadModal;
});
